import { UserModel } from 'app/models/user.model';
import { CompanyModel } from 'app/models/company.model';

export const REQUESTER_HOME_PATH = '/requester/home';

export function isRequesterCompanyKind(kind: string | null | undefined): boolean {
    return kind === 'requester';
}

export function isOperationalCompanyKind(kind: string | null | undefined): boolean {
    return kind === 'manager' || kind === 'client';
}

/** Empresa usa o app Prehox como tenant operacional. `false` = parceira só despacho externo. */
export function usesPrehoxApp(company: { uses_prehox_app?: boolean | null } | null | undefined): boolean {
    return company?.uses_prehox_app !== false;
}

function collectUserCompanyKinds(user: UserModel | null | undefined): string[] {
    const kinds: string[] = [];
    const companies = (user as any)?.companies as Array<{ company_kind?: string }> | undefined;
    (companies || []).forEach((c) => {
        if (c?.company_kind) kinds.push(c.company_kind);
    });
    const userCompanies = (user as any)?.user_companies as Array<{ company?: { company_kind?: string } }> | undefined;
    (userCompanies || []).forEach((uc) => {
        if (uc?.company?.company_kind) kinds.push(uc.company.company_kind);
    });
    const nested = (user as any)?.company?.company_kind;
    if (nested) kinds.push(nested);
    return kinds;
}

export function isRequesterUser(user: UserModel | null | undefined, company?: CompanyModel | null): boolean {
    if (!user || user.is_admin) {
        return false;
    }
    const kinds = collectUserCompanyKinds(user);
    const hasRequester = kinds.some((kind) => isRequesterCompanyKind(kind));
    const hasOperational = kinds.some((kind) => isOperationalCompanyKind(kind));
    if (hasRequester && !hasOperational) {
        return true;
    }
    return hasRequester && isRequesterCompanyKind(company?.company_kind);
}

export function getRequesterCompany(user: UserModel | null | undefined): Partial<CompanyModel> | null {
    const companies = ((user as any)?.companies || []) as Array<Partial<CompanyModel>>;
    const fromCompanies = companies.find((c) => isRequesterCompanyKind(c?.company_kind));
    if (fromCompanies) return fromCompanies;
    const userCompanies = ((user as any)?.user_companies || []) as Array<{ company?: Partial<CompanyModel> }>;
    const fromLink = userCompanies.find((uc) => isRequesterCompanyKind(uc?.company?.company_kind))?.company;
    return fromLink || null;
}

export function resolveRequesterHomePath(user: UserModel | null | undefined, company?: CompanyModel | null): string | null {
    if (isRequesterUser(user, company)) {
        return REQUESTER_HOME_PATH;
    }
    return null;
}

export function usesRequesterServiceList(company?: CompanyModel | null): boolean {
    return isRequesterCompanyKind(company?.company_kind);
}

export function isRequesterPortalContext(
    user: UserModel | null | undefined,
    company?: CompanyModel | null,
    url?: string,
): boolean {
    const path = (url || '').split('?')[0];
    const onRequesterRoute = path.startsWith('/requester');
    const onRequesterServices = path === '/requester/services' || path.startsWith('/requester/services/');

    if (onRequesterRoute) {
        return true;
    }

    if (isRequesterUser(user, company) && onRequesterServices) {
        return true;
    }

    if (user?.is_admin && isRequesterCompanyKind(company?.company_kind) && onRequesterServices) {
        return true;
    }

    return false;
}
